import script from "./form-console.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-console.vue?vue&type=script&setup=true&lang=ts"

import "./form-console.vue?vue&type=style&index=0&id=21e2a45c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21e2a45c"]])

export default __exports__